module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"The Gender Bias Decoder","short_name":"The Gender Bias Decoder","start_url":"/","background_color":"#F4F4F4","theme_color":"#292A36","display":"standalone","icon":"src/images/favicon/favicon.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
